export const images = {
  hero: "https://cdn.magicpatterns.com/uploads/ssVqrsGtd38EsGdRugae5y/10_12_24___i9_Marketing0791.jpg",
  mission: "https://cdn.magicpatterns.com/uploads/cxjfs4zVELdBAuJ9ovCCpy/A7509059.jpg",
  logo: "https://cdn.magicpatterns.com/uploads/q7JYXFGeACRzTUWj1tkjk4/I9_Logo_Hi_Res_Multicolor.png",
};
